import React from "react";
import styled from 'styled-components/macro';
import Grafica from "./Grafica/Grafica";
import { option as optionBarPartido } from '../components/Grafica/BarPartido'
import { useNomenclator } from "../contexts/nomenclatorContext";
import CardPartidoPresidencia from "./Cards/CardPartidoPresidencia";
import { responsive } from '../resources/constantes.json';
import { useIsMobile } from "../hooks/useMediaQuery.js";
import useWindowWidth from "../hooks/useWindowWidth";


const PartidoPresidencia = ({ partido, horizontal, index, hasData }) => {
	const nomenclator = useNomenclator();
	const isMobile = useIsMobile();
	const windowWidth = useWindowWidth();
	const left = index===0 
	return (
		<ContentPartido horizontal={horizontal} left={left}>
			<CardContainer left={left}>
				<CardPartidoPresidencia left={ left } horizontal={horizontal} partido={partido} />
			</CardContainer>
			<BarLogoContainer horizontal={horizontal} left={ left }>
				<BarContainer horizontal={horizontal}>
					<Grafica
						option={optionBarPartido(partido, nomenclator, horizontal, isMobile, windowWidth, hasData)}
						css={`
							height: ${horizontal ? '50px' : '550px'};
							display:flex;
							width:200px;
							@media screen and (max-width: ${responsive.tablet}px) {
								width: 100%;
							}
							@media screen and (max-width: ${responsive.mobile}px) {
								height:35px;
							}
						`}
						animationDelay={500}
					/>
				</BarContainer>
			</BarLogoContainer>
		</ContentPartido>
	)
}


const BarLogoContainer = styled.div`
	display:flex;
	align-items: center;
	flex-direction: column;
	width: 30%;
	order: ${({left}) => left ? '2' : '1'};
	@media screen and (max-width: ${responsive.tablet}px) {
		// max-width:400px;
		width:100%;
		// gap: 10px;
	}
	
	`
	
const CardContainer = styled.div`
	display:flex;
	order: ${({left}) => left ? '1' : '2'};
	max-width:400px;
	@media screen and (max-width: ${responsive.tablet}px) {
		max-width:100%;
		gap: 10px;
	}
	width:100%;
`

const BarContainer = styled.div`
	display:flex;
	flex-direction: 'column';
	align-items:center;

	@media screen and (max-width: 1365px) {
		width:100%;
	}
`

const ContentPartido = styled.div`
	height:100%;
	width: 100%;
	display: flex;
	align-items:flex-end;
	flex-direction: ${({ horizontal }) => horizontal ? 'column' : 'row'};
	justify-content: ${({left}) => left ? 'right' : 'left'};
	${({ horizontal }) => horizontal && `
		// background: #FFFFFF;
		// box-shadow: 0px 0px 3px 2px rgba(0, 0, 0, 0.05);
		// border-radius: 3px;
		padding: 1rem 0;
		align-items:center;
		width:100%;
		gap:2rem;
	`};
`


export default PartidoPresidencia;